import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getClassNames, isBrowser } from '@websolutespa/bom-core';
import { useMounted } from '@websolutespa/bom-mixer-hooks';
import { IconLlmMinimize, IconLlmPlay, IconLlmMaximize } from '@websolutespa/bom-mixer-icons';
import { useRef, useEffect, useMemo, useState } from 'react';
import { Dialog } from '../Dialog/dialog.js';

const StaticNode = _a => {
  var {
      outerRef,
      playing
    } = _a,
    props = __rest(_a, ["outerRef", "playing"]);
  const innerRef = useRef(null);
  useEffect(() => {
    if (innerRef.current && outerRef.current) {
      outerRef.current.removeAttribute('style');
      innerRef.current.appendChild(outerRef.current);
    }
  }, [innerRef, outerRef]);
  const onClose = () => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  };
  const classNames = getClassNames('llm__thron-player', 'llm__video', '-enlarged', {
    '-playing': playing
  });
  return jsxs(Fragment, {
    children: [jsx("div", {
      ref: innerRef,
      className: classNames
    }), jsx("button", {
      type: "button",
      className: "llm__video-reduce",
      onClick: () => onClose(),
      "aria-label": "Reduce",
      children: jsx(IconLlmMinimize, {})
    })]
  });
};
const ThronPlayer = props => {
  const id = useMemo(() => {
    return `video-${props.media.xcontentId}-${Math.round(Math.random() * 10000)}`;
  }, [props.media.xcontentId]);
  const mounted = useMounted();
  const innerRef = useRef(null);
  const elementRef = useRef();
  const playerRef = useRef();
  const [ready, setReady] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [enlarged, setEnlarged] = useState(false);
  useEffect(() => {
    if (innerRef.current && elementRef.current && !enlarged) {
      elementRef.current.removeAttribute('style');
      innerRef.current.appendChild(elementRef.current);
    }
  }, [innerRef, elementRef, ready, enlarged]);
  useEffect(() => {
    if (isBrowser && mounted) {
      let element = undefined;
      let player = undefined;
      const onPlay = () => {
        setPlaying(true);
      };
      const onPause = () => {
        setPlaying(false);
      };
      const onReady = () => {
        elementRef.current = element;
        playerRef.current = player;
        setReady(true);
      };
      const onLoad = () => {
        const options = {
          clientId: props.media.clientId,
          xcontentId: props.media.xcontentId,
          sessId: props.media.sessId,
          autoplay: false,
          muted: false,
          noSkin: false
        };
        try {
          // console.log('THRONContentExperience', (window as any)['THRONContentExperience']);
          if ('THRONContentExperience' in window) {
            element = document.createElement('div');
            element.setAttribute('id', id);
            element.setAttribute('style', 'width:100vw;height:56.25vw;');
            document.body.appendChild(element);
            const THRONContentExperience = window['THRONContentExperience'];
            player = THRONContentExperience(id, options);
            // console.log('player', player);
            player.on('play', onPlay);
            player.on('pause', onPause);
            player.on('ready', onReady);
          }
        } catch (error) {
          console.log('ThronPlayer.error', error);
        }
      };
      const thronEmbedScript = document.querySelector('#thron-embed-script');
      if (!thronEmbedScript) {
        const script = document.createElement('script');
        script.id = 'thron-embed-script';
        script.src = 'https://legadelfilodoro-cdn.thron.com/shared/ce/bootstrap/1/scripts/embeds-min.js';
        script.async = true;
        script.onload = onLoad;
        document.head.appendChild(script);
      } else {
        onLoad();
      }
      return () => {
        if (playerRef.current) {
          playerRef.current.off('play', onPlay);
          playerRef.current.off('pause', onPause);
          playerRef.current.off('ready', onReady);
        }
      };
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, mounted]);
  const onClick = () => {
    if (playerRef.current) {
      playerRef.current.play();
    }
  };
  const onEnlarge = () => {
    if (playerRef.current) {
      setEnlarged(true);
    }
  };
  const onReduce = () => {
    if (playerRef.current) {
      setEnlarged(false);
    }
  };
  const classNames = getClassNames('llm__thron-player', 'llm__video', {
    '-playing': playing
  });
  return jsxs("div", {
    className: classNames,
    children: [jsx("div", {
      ref: innerRef
    }), jsx("button", {
      type: "button",
      className: "llm__video-play",
      onClick: () => onClick(),
      "aria-label": "Play",
      children: jsx(IconLlmPlay, {})
    }), jsx("button", {
      type: "button",
      className: "llm__video-enlarge",
      onClick: () => onEnlarge(),
      "aria-label": "Enlarge",
      children: jsx(IconLlmMaximize, {})
    }), jsx(Dialog, {
      visible: enlarged,
      onClose: onReduce,
      children: jsx(StaticNode, {
        outerRef: elementRef,
        playing: playing,
        onClose: onReduce
      })
    })]
  });
};

export { StaticNode, ThronPlayer };
//# sourceMappingURL=thron-player.js.map
